module.exports = __webpack_public_path__ + "static/media/19_tn.0efbbfeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/19_tn.jpg
// module id = 449
// module chunks = 0